import { render, staticRenderFns } from "./CpdSendConfirmDialog.vue?vue&type=template&id=7972b904&"
import script from "./CpdSendConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./CpdSendConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./CpdSendConfirmDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports